<template>
  <div>
    <div v-for="item in projNow" :key="item.id">
		<!-- Title page -->
		<div>
			<div class="title-img">
				<img :src="require('../../assets/designProjects/' + item.img)">
				<div class="title-img-overlay"></div>
			</div>
			<b-container fluid class="title-des">
				<b-col class="col-lg-3 col-md-4 col-sm-6">
					<h1 class="text-info text-left">{{ item.title }}</h1>
					<p class="text-white">{{ item.description }}</p>
				</b-col>
			</b-container>
		</div>
		<!-- Header -->
		<Header></Header>
		<!-- Project Info -->
		<b-container class="d-none d-lg-block d-xl-block content-left">
			<b-col class="col-lg-2">
				<div class="my-5">    
					<h5 class="text-info">Type</h5>
					<p>{{ item.type }} <br>{{ item.skill }}</p>
				</div>
				<div class="my-5">    
					<h5 class="text-info">Duration</h5>
					<p>{{ item.time }} <br>{{ item.duration }}</p>
				</div>
				<div class="my-5">    
					<h5 class="text-info">Team</h5>
                    <p>Akari Takada <br>Andrés Restrepo <br>Sam Lonis <br>Rengarajan Manivannan </p>
				</div>
				<!-- <div class="my-5">
					<h5 class="text-info">Skills</h5>
					<p>edit here</p>
				</div> -->
			</b-col>
		</b-container>
		<!-- Overview -->
		<b-container class="my-5">
			<h2 class="my-4 text-light">Overview</h2>
			<b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
				<b-row class="align-items-center">
					<b-col class="my-2 w-430">
						<h5 class="text-info">Context</h5>
						<h3>Tourism in Amsterdam.</h3>
						<p>Amsterdam, known as the liberal capital of the Netherlands, is one of the most popular destinations, consistently landing in the top 10 most visited cities in Europe (Euromonitor).</p>
					</b-col>
					<b-col md class="my-2 px-0">
						<div>
							<img class="rounded-img" src="../../assets/designProjects/trufoo/amsterdam.jpg" alt="">
							<p class="text-right w-100"><small>Source: Max van den Oetelaar / Unsplash</small></p>
						</div>
					</b-col>
				</b-row>
			</b-col>
		</b-container>
		<!-- Problem -->
		<b-container class="bg-custom py-5 my-5">
			<b-col class="my-2 col-lg-9 col-md-12 col-sm-12 mx-auto">
				<b-row>
					<b-col class="my-2 w-430">
						<h5 class="text-info">Problem</h5>
						<h3>Effects of mass tourism.</h3>
						<p>Amsterdam is facing social and environmental problems due to overtourism. This includes excess waste, visual contamination, and threats to local culture.</p>
					</b-col>
				</b-row>
				<b-row class="my-2">
					<img class="rounded-img" src="../../assets/designProjects/trufoo/overtourism.jpg" alt="">
					<p class="text-right w-100"><small>Source: Robin Utrecht / Getty Images</small></p>
				</b-row>
			</b-col>
		</b-container>
		<b-container class="bg-problem py-5 my-5">
			<h3 class="text-white m-0">How can mass tourists in Amsterdam be more environmentally sustainable?</h3>
		</b-container>
		<!-- Solution -->
		<b-container class="my-5">
			<b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
				<b-row>
					<b-col class="my-2 w-430">
						<h5 class="text-info">Solution</h5>
						<h3>TRU FOO.</h3>
						<p>A food truck in circular economy that offers tourists sustainable, organic, and locally-produced eating options.</p>
					</b-col>
				</b-row>
			</b-col>
			<b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
				<b-row class="banner">
					<div>
						<img class="rounded-img" src="../../assets/designProjects/trufoo/thumbnail.png" alt="">
						<div class="banner-img-overlay"></div>
					</div>
					<div class="banner-des w-430">
						<h4 class="text-white">A win-win for tourists and locals.</h4>
						<p class="text-white">Boosting local economy and providing compost to local suppliers, while providing tourists with convenient food.</p>
					</div>
				</b-row>
				<b-row class="my-5">
					<img class="rounded-img" src="../../assets/designProjects/trufoo/circular-economy.png" alt="">
				</b-row>
			</b-col>
			<b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
				<b-row class="align-items-center">
					<b-col md>
						<div class="my-2">
							<h4>Easily adaptable for tourists.</h4>
							<p>TRU FOO does not require the tourists to change their behavior since eating is a daily necessity.</p>
						</div>
					</b-col>
					<b-col md class="my-2 p-0">
						<div>
							<img class="rounded-img" src="../../assets/designProjects/trufoo/menu.png" alt="">
						</div>
					</b-col>
				</b-row>
			</b-col>
			<b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
				<b-row class="align-items-center">
					<b-col md class="my-2 p-0">
						<div>
							<img class="rounded-img" src="../../assets/designProjects/trufoo/info-panel.png" alt="">
						</div>
					</b-col>
					<b-col md class="my-2 ml-xl-3 ml-lg-3 ml-md-3">
						<div>
							<h4>Connecting tourists with the locals.</h4>
							<p>Information about the local suppliers creates an indirect but deep sense of connection with the locals.</p>
						</div>
					</b-col>
				</b-row>
			</b-col>
			<b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
				<b-row>
					<b-col class="mt-2 w-430">
						<h4>Raising awareness for Dutch culture.</h4>
						<p>Fully Dutch cuisine and fun facts about the Netherlands on the packaging to promote culture.</p>
					</b-col>
				</b-row>
				<b-row class="my-2">
					<img class="rounded-img" src="../../assets/designProjects/trufoo/packaging.png" alt="">
				</b-row>
			</b-col>
			<b-col class="my-5 col-lg-9 col-md-12 col-sm-12 mx-auto">
				<b-row>
					<b-col class="mt-2 w-430">
						<h4>Dispersing the crowd.</h4>
						<p>Information about destinations on the interactive map change according to real-time data on the number of people at each destination.</p>
					</b-col>
				</b-row>
				<b-row class="my-2">
					<img class="rounded-img" src="../../assets/designProjects/trufoo/map.png" alt="">
				</b-row>
			</b-col>
		</b-container>
    </div>
	<footerProjects></footerProjects>
</div>
</template>

<script>
import csvData from '../../data/designProjectInfo.csv'
const Header = () => import('../../components/Header.vue')
const footerProjects = () => import('../../components/footerProjects.vue')

  var now = 'trufoo';

  export default {
    name: 'trufoo',
    title: 'TRU FOO Amsterdam',
    components: {
      'Header': Header,
      'footerProjects': footerProjects,
    },
    data: () => {
      return {
        items : csvData
      }
    },
    computed: {
      projNow() {
        return this[this.$i18n.locale].filter((item) => item.code == now);
      },
      ja() {
        return this.items.filter((item) => item.lang == 'ja' );
      },
      en() {
        return this.items.filter((item) => item.lang == 'en');
      },
      path() {
        return this.item.path;
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" src="@/scss/designProjects.scss">
</style>